// extracted by mini-css-extract-plugin
export default {"ratingCard":"RatingSummaryCard_ratingCard__QvS1m"};